<template>
  <div class="location-down-message-outer-container">
    <div class="location-down-message-inner-container" v-for="( hb, key ) in heartbeats" :key="key">
      <div class="location-down-message-main" v-if="!hb">{{ capitalize( key ) }} is currently unavailable</div>
    </div>
  </div>
</template>

<script>

export default {
  computed: {
    heartbeats() {
      return this.$store.state.availability.heartbeats
    }
  },
  methods: {
    capitalize( name ) {
      return name.charAt(0).toUpperCase() + name.slice(1)
    }
  }
}
</script>

<style lang="scss" scoped>

.location-down-message-inner-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.location-down-message-main {
  border: 1px solid red;
  color: red;
  padding: 3px;
  margin: 5px;
  border-radius: 3px;
  width: 70%;
}
</style>